export const RegularExpressions = {
    noSpecialCharacters: /^[a-z ,.'-]+$/i,
    noSpecialCharactersLight: /^[a-z \d ,.'-/\\&]+$/i,
    password: /^(?=^.{8,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*\W+).*$/g,
    passwordWithOutG: /^(?=^.{8,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*\W+).*$/,
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    pinCode: /^\d{2}-\d{2}$/,
    verifyCode: /\d{6}$/,
    website: /(https?:\/\/)?(www\.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)|(https?:\/\/)?(www\.)?(?!ww)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i,
    phoneNumber: /^([+][0-9]+)(\d{3}|[0-9])?([0-9])+$/,
    dateOfIncident: /^\d{4}-\d{2}-\d{2}$/,
}
